/* tslint:disable:max-line-length */
import { isPlatformBrowser } from "@angular/common";
import { ChangeDetectorRef, ElementRef, EventEmitter, OnInit, } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { VenueService } from "../venue.service";
import { SearchListLinkService } from "./../../shared/search.list.link.service";
import { ModalService, mlpEmailValidator } from "pf_styleguide";
import { ContactDetailsService } from "./../../shared/module/contact-details/contact.details.service";
import { ApiEndpoints } from "./../../shared/apiEndpoints";
import { SearchService } from "app/search-results/search.service";
import { FormBuilder, Validators } from "@angular/forms";
import { MandrillService } from "app/partner/mandrill.service";
import { CLAIM_VENUE_TEMPLATE, NotifyMePayload } from "app/shared/model/venue-content.interface";
import { contactVenuePayload, notifyMePayload } from "app/shared/model/venue-content.data";
import { EventTrackingService } from "app/shared/eventTracking.service";
import { GenericService } from "app/shared/generic.service";
import { ConfigureService } from "app/configure/configure.service";
import { MandrillEmailTemplate } from "app/shared/model/mandrillEmailTemplate";
import { MandrillEmailRecipient } from "app/shared/model/mandrillEmailRecipient";
import { finalize } from "rxjs/operators";
import { CustomValidators } from "app/shared/validator/customValidators";
var VenueContentComponent = /** @class */ (function () {
    function VenueContentComponent(venueService, route, router, modalService, searchListLinkService, contactService, apiEndpoints, searchService, platformId, cdef, fb, config, eventTrackingService, genericService, mandrillService) {
        var _this = this;
        this.venueService = venueService;
        this.route = route;
        this.router = router;
        this.modalService = modalService;
        this.searchListLinkService = searchListLinkService;
        this.contactService = contactService;
        this.apiEndpoints = apiEndpoints;
        this.searchService = searchService;
        this.platformId = platformId;
        this.cdef = cdef;
        this.fb = fb;
        this.config = config;
        this.eventTrackingService = eventTrackingService;
        this.genericService = genericService;
        this.mandrillService = mandrillService;
        this.similarPitchData = null;
        this.similarPitchesDisplayCount = 3;
        this.pitchesWithUniqueSports = [];
        this.sport = "";
        this.city = "";
        this.isBrowser = isPlatformBrowser(this.platformId);
        this.modalMobile = {
            size: "sm",
            keyboard: false,
        };
        this.openMapEvent = new EventEmitter();
        this.pitchesWithSameSport = [];
        this.venueService.pitchDataChange.subscribe(function () {
            _this.sport = _this.venueService.pitchData.data.attributes.sport;
            _this.contactService.isMLP =
                _this.venueService.pitchData.data.attributes.mlp;
            _this.contactService.checkIsVisible();
        });
        this.venueService.venueDataChange.subscribe(function (data) {
            _this.filterUniqueSports(data.included);
        });
        this.formGroup = this.fb.group({
            email: ['', [Validators.required, Validators.email]]
        });
        this.claimVenueFormGroup = this.fb.group({
            fullName: [undefined],
            email: [undefined, [Validators.required, mlpEmailValidator()]],
            phoneNumber: [
                undefined,
                [CustomValidators.phoneNumber()],
            ],
            role: [undefined],
            message: [undefined, [Validators.required]],
        });
        this.isLoading = false;
    }
    VenueContentComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route$ = this.route.paramMap;
        this.route$.subscribe(function (params) {
            _this.city = params.get("city");
        });
        if (this.venueService.pitchData) {
            this.sport = this.venueService.pitchData.data.attributes.sport;
            this.filterUniqueSports(this.venueService.venueData.included);
        }
    };
    VenueContentComponent.prototype.lowercase = function (value) {
        if (value) {
            return value.toLowerCase();
        }
    };
    VenueContentComponent.prototype.viewSearchResults = function () {
        if (this.venueService.pitchData &&
            this.venueService.venueData &&
            this.city) {
            if (!this.searchListLinkService.wasSearchResultsPage) {
                this.router.navigate([
                    this.city,
                    "results",
                    this.venueService.pitchData.data.attributes.sport.replace(/\s+/g, "-"),
                ], {
                    queryParams: {
                        latitude: this.venueService.venueData.data.attributes
                            .latitude,
                        longitude: this.venueService.venueData.data.attributes
                            .longitude,
                        radius: "5mi",
                        formats: this.venueService.pitchData.data.attributes
                            .format,
                        surfaces: this.venueService.pitchData.data.attributes
                            .surface,
                    },
                });
            }
            if (this.searchListLinkService.wasSearchResultsPage) {
                this.searchListLinkService.backInHistory();
            }
        }
    };
    VenueContentComponent.prototype.filterUniqueSports = function (pitches) {
        var _this = this;
        this.pitchesWithUniqueSports = [];
        pitches.forEach(function (pitchData) {
            var sportFound = false;
            _this.pitchesWithUniqueSports.forEach(function (existingPitch) {
                if (existingPitch.attributes.sport ===
                    pitchData.attributes.sport) {
                    sportFound = true;
                }
            });
            if (!sportFound) {
                _this.pitchesWithUniqueSports.push(pitchData);
            }
        });
    };
    VenueContentComponent.prototype.openContactVenueModal = function () {
        var _this = this;
        if (!this.similarPitchData) {
            this.apiEndpoints
                .callMlpApiGetPitchCollectionFromLocation(this.venueService.pitchData, 6, 1)
                .subscribe(function (pitches) {
                _this.similarPitchData = [];
                pitches.data.forEach(function (pitch) {
                    if (pitch.id != _this.venueService.pitchData.data.id) {
                        var venueFound_1;
                        pitches.included.forEach(function (venue) {
                            if (venue.id ==
                                pitch.relationships.venues.data.id) {
                                venueFound_1 = venue;
                            }
                        });
                        _this.similarPitchData.push({
                            pitch: pitch,
                            venue: venueFound_1,
                        });
                    }
                });
                _this.modalService
                    .open(_this.contactVenueModal, { size: 'lg' });
            });
        }
        else {
            this.modalService.open(this.contactVenueModal, { size: 'lg' });
        }
    };
    VenueContentComponent.prototype.milesAway = function (venue) {
        var dist = this.getDistanceFromLatLonInMiles(this.venueService.venueData.data.attributes.latitude, this.venueService.venueData.data.attributes.longitude, venue.attributes.latitude, venue.attributes.longitude);
        var distRounded = Math.round(dist * 10 + Number.EPSILON) / 10;
        return !isNaN(distRounded)
            ? distRounded + " " + (distRounded === 1 ? "mile" : "miles") + " away"
            : "";
    };
    VenueContentComponent.prototype.getDistanceFromLatLonInMiles = function (lat1, lon1, lat2, lon2) {
        var mileConversion = 0.621371;
        var earthRadius = 6371; // Radius of the earth in km
        var dLat = this.deg2rad(lat2 - lat1);
        var dLon = this.deg2rad(lon2 - lon1);
        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(this.deg2rad(lat1)) *
                Math.cos(this.deg2rad(lat2)) *
                Math.sin(dLon / 2) *
                Math.sin(dLon / 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return earthRadius * c * mileConversion;
    };
    VenueContentComponent.prototype.deg2rad = function (deg) {
        return deg * (Math.PI / 180);
    };
    VenueContentComponent.prototype.areAvailableSlots = function (pitch) {
        return !!(pitch.attributes.online_booking &&
            pitch.attributes.available_slots_total);
    };
    VenueContentComponent.prototype.resetForm = function (form) {
        this.isLoading = false;
        this.success = false;
        this.submitted = false;
        form.reset();
        form.markAsPristine();
        form.markAsUntouched();
        form.updateValueAndValidity();
    };
    VenueContentComponent.prototype.openContactVenueFormModal = function () {
        this.modalService.close();
        this.resetForm(this.formGroup);
        this.modalService
            .open(this.contactVenueFormModal, { size: 'lg' });
    };
    VenueContentComponent.prototype.getVenueDataFromPitch = function () {
        var _this = this;
        var venueData = null;
        if (!this.venueService.pitchData) {
            return;
        }
        this.venueService.pitchData.included.forEach(function (venue) {
            if (_this.venueService.pitchData.data.relationships.venues.data.id == venue.id) {
                venueData = venue;
            }
        });
        return venueData;
    };
    VenueContentComponent.prototype.validContactDetails = function () {
        var venue = this.getVenueDataFromPitch();
        return venue && venue.attributes.show_phone && !venue.attributes.contact_number.includes('000000');
    };
    VenueContentComponent.prototype.notifyMe = function () {
        var _this = this;
        this.submitted = true;
        if (this.formGroup.valid) {
            var email = this.formGroup.get('email').value;
            var payload = notifyMePayload;
            payload.data.attributes.email = email;
            payload.included[0].attributes.value = this.venueService.venueData.data.id;
            this.isLoading = true;
            this.apiEndpoints
                .notifyMe(payload)
                .pipe(finalize(function () { return (_this.isLoading = false); }))
                .subscribe(function (data) {
                _this.success = true;
            });
        }
    };
    VenueContentComponent.prototype.sendVenueContactStatus = function (status) {
        var _this = this;
        var payload = contactVenuePayload;
        payload.data.attributes = {
            venue: this.getVenueDataFromPitch().id,
            contacted: status,
        };
        this.isLoading = true;
        this.apiEndpoints
            .contactedVenue(payload)
            .pipe(finalize(function () { return (_this.isLoading = false); }))
            .subscribe(function (_) {
            _this.eventTrackingService.trackEvent("Contact Message Sent", _this.getEventTrackingActionName(), "Contact Message Sent");
            _this.success = true;
        });
    };
    VenueContentComponent.prototype.getEventTrackingActionName = function () {
        return "Contact Venue";
    };
    Object.defineProperty(VenueContentComponent.prototype, "email", {
        get: function () {
            return this.formGroup.get("email");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VenueContentComponent.prototype, "fullName", {
        get: function () {
            return this.claimVenueFormGroup.get("fullName");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VenueContentComponent.prototype, "claimVenueEmail", {
        get: function () {
            return this.claimVenueFormGroup.get("email");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VenueContentComponent.prototype, "phoneNumber", {
        get: function () {
            return this.claimVenueFormGroup.get("phoneNumber");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VenueContentComponent.prototype, "role", {
        get: function () {
            return this.claimVenueFormGroup.get("role");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VenueContentComponent.prototype, "message", {
        get: function () {
            return this.claimVenueFormGroup.get("message");
        },
        enumerable: true,
        configurable: true
    });
    VenueContentComponent.prototype.openClaimVenueModal = function () {
        this.resetForm(this.claimVenueFormGroup);
        this.modalService
            .open(this.claimVenueFormModal, {
            size: 'lg'
        });
    };
    VenueContentComponent.prototype.getVerified = function () {
        var _this = this;
        if (!this.claimVenueFormGroup.valid) {
            return;
        }
        var emailRecipient = new MandrillEmailRecipient(this.claimVenueEmail.value);
        var mandrillEmailTemplate = new MandrillEmailTemplate(CLAIM_VENUE_TEMPLATE, [emailRecipient], [
            { name: "fullName", content: this.fullName.value },
            { name: "email", content: this.claimVenueEmail.value },
            { name: "phoneNumber", content: this.phoneNumber.value },
            { name: "role", content: this.role.value },
            { name: "message", content: this.message.value },
            { name: 'venueName', content: this.venueService.venueData.data.attributes.name }
        ], this.config);
        this.isLoading = true;
        this.mandrillService
            .sendTemplate(mandrillEmailTemplate)
            .pipe(finalize(function () { return (_this.isLoading = false); }))
            .subscribe(function (data) {
            _this.eventTrackingService.trackEvent("Claim Venue Message Sent", "Claim Venue", "Claim Venue Message Sent");
            _this.success = true;
        });
    };
    VenueContentComponent.prototype.scrollToTheTop = function () {
        window.scrollTo(0, 0);
    };
    return VenueContentComponent;
}());
export { VenueContentComponent };
